import * as fieldTypes from '../../../../../../constants/FieldTypes';

export function findFieldByName(fields, name) {
    return fields.find(field => field.name === name);
}

export function setScreenChanged(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
}

export function changeParent(field, parentField) {
    // if we move field to a hidden tab, it turns to hidden itself
    if (parentField.hidden) {
        field.setHide(true);
        // if there's a merged field, it also turns to hidden
        if (field.mergedField) {
            field.mergedField.setHide(true);
        }
    }
    // newarea is reseted when a field is moved
    if (field.newarea) {
        field.setNewArea(false);
    }

    const removedField = field.parentCollection.removeField(field);
    // change parents' names
    field.parentField = parentField;
    parentField.collection.setField(removedField, parentField.collection.firstHiddenIdx);
    parentField.collection.setExpanded(true);
    field.setMoved(true);
}

export function moveFieldToAnotherTab(field, destination) {
    const {
        screen: {
            collection: {fields}
        }
    } = field;
    setScreenChanged(field);
    const newTab = findFieldByName(fields, destination);
    changeParent(field, newTab);
}

export function isMoveBetweenTabsDisabled(field) {
    return (
        field.type === fieldTypes.TAB || field.parentField.type !== fieldTypes.TAB || field.merged
    );
}
